import React from "react"
import { Link } from "react-router-dom"

import KnowledgeListItem from "../../common/knowledge-list/KnowledgeListItem"

const DashboardKnowledgeListItem = props => (
    <Link to={`/knowledge/${props.id}`} style={{ textDecoration: "none" }}>
        <KnowledgeListItem {...props} showApproved={true} />
    </Link>
)

export default DashboardKnowledgeListItem
